import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
                        <h2> Our <span>App Maintenance Services</span> for Specific Industries</h2>
                        <p>Our app maintenance services guarantee optimized performance and relevance. With a focus on expertise, we provide comprehensive solutions addressing the unique challenges of diverse sectors, from healthcare to finance.You can collaborate with us for reliable support, ensuring your mobile applications stay secure and aligned with industry standards.</p>
                        <p>TekRevol offers efficient maintenance and regular support for the following industries:</p>
                        <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Let’s Update Your App’s Performances</Link>
                    </Col>
                    <Col xs={12} md={4} lg={4} xl={4} xxl={4} className="offset-lg-3 offset-md-3 my-auto">
                        <div className="industry_scroll">
                            <h3>Fintech</h3>
                            <h3>Healthcare</h3>
                            <h3>E-commerce</h3>
                            <h3>Real Estate</h3>
                            <h3>Automotive</h3>
                            <h3>On-Demand</h3>
                            <h3>Education</h3>
                            <h3>Music</h3>
                            <h3>IT Staff Augmentation</h3>
                            <h3>Logistics</h3>
                            <h3>Retail</h3> 
                        </div>
                    </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Industryusa